<script>
import BatchHeader from "@/components/BatchHeader.vue";
import WorkflowNotes from "@/components/WorkflowNotes.vue";

export default {
  name: "BatchView",
  components: {WorkflowNotes, BatchHeader},
  data() {
    return {
      batchId: 0,
      batch: {},
      headerRefreshNotes: false,
      workflowState: 10,
      workflowStates: [
        { id: 10, label: "Eingang" },
        { id: 20, label: "Waschen" },
        { id: 30, label: "Trocknung" },
        { id: 40, label: "Reinigung" }
      ],
      noteData: {
        text: '',
        images: [],
      },
      storing: false,
    }
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  async created() {
    this.setBatchId(this.id)
    await this.$store.dispatch('initItems', {entityName: 'batch'})
    await this.$store.dispatch('getItemList', {entityName: 'supplier'})
    await this.$store.dispatch('getItemList', {entityName: 'regrater'})
    await this.$store.dispatch('getItemList', {entityName: 'product'})
    this.batch = this.$store.state.batch.find(batch => batch.batchId == this.batchId)

    const stateMatch = this.workflowStates.findIndex(state => state.id == this.batch.workflowState)
    if (stateMatch >= 0) this.workflowState = this.batch.workflowState
  },
  computed: {
    canWrite() {
      return this.$store.getters.canWrite
    },
  },
  methods: {
    setBatchId(id) {
      const pos = id.indexOf('.')
      if (pos >= 0)
        id = id.substring(0, pos)
      if (id.indexOf('CH') === 0)
        id = id.substring(2)

      this.batchId = id
    },
    getSupplier(id) {
      if (!id || !this.$store.state.supplier) return ''
      const item = this.$store.state.supplier.find(item => item.contactId === id)
      //TODO if item missing: request from server by two credentials to validate
      if (!item) return null
      return item
    },
    getSupplierName(id) {
      const item = this.getSupplier(id)

      if (!item) return '–'
      return item.name
    },
    getRegrater(id) {
      if (!id || !this.$store.state.regrater) return '–'
      const item = this.$store.state.regrater.find(item => item.contactId === id)
      if (!item) return '–'
      return item.name
    },
    getProduct(id) {
      if (!id || !this.$store.state.product) return '–'
      const item = this.$store.state.product.find(item => item.productId === id)
      if (!item) return '–'
      return item.name
    },
    refreshed({what}) {
      switch (what) {
        case 'notes':
          this.headerRefreshNotes = false
          break;
      }
    },
    async storeImages() {
      this.storing = true
      const data = {
        batchUid: this.batch.uniqueId,
        workflowStep: this.workflowState,
        noteImages: this.noteData.images,
      }
      console.log('storeImages', data)
      const response = await this.$store.dispatch('uploadItem',
          {name: 'image', id: this.batch.batchId, data})

      this.storing = false
      if (response && response.success) {
        // reset images
        this.noteData.images = []
        this.headerRefreshNotes = true
      }
    }
  }
}
</script>

<template>
  <batch-header
      :batch-id="batchId"
      :batch="batch"
      :can-write="false"
      :supplierName="getSupplierName(batch.supplierId)"
      :regraterName="getRegrater(batch.regraterId)"
      :productName="getProduct(batch.productId)"
      :refresh-notes="headerRefreshNotes"
      @refreshed="refreshed"/>

  <h2 class="mt-3">Foto/s hinzufügen</h2>
  <form @submit.prevent="false" class="row">
    <div class="input-group col-8 mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="stockLocation">Arbeitsschritt</label>
      </div>
      <select v-model="workflowState"
              class="custom-select custom-select-lg" id="stockLocation">
        <option
            v-for="(item, index) in workflowStates"
            :key="index"
            :value="item.id">{{ item.label }}</option>
      </select>
    </div>
  </form>
  <workflow-notes :note-data="noteData" :can-write="canWrite" :text-note="false"/>

  <div v-if="storing" class="col-8 mt-3 text-center">
    Die Daten werden gespeichert...
  </div>
  <button @click="storeImages" class="mt-5 mb-3" type="button" :disabled="storing">Hinzufügen</button>

</template>

<style scoped>

</style>